import { FC, useContext, useEffect, useRef, useState } from "react";
import { Button, CustomLink, Input, Layout, PhotoIcon, Result, Row } from "../../components";
import logo from "../../assets/logo.svg";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { Context } from "../..";
import axios from "axios";
import config from "../../config";
import $api from "../../http";
import { Response } from "../../types";
import { observer } from "mobx-react";

const FileInput = styled.input`
  display: none;
`;

const ImageUploader = styled.label`
  border-radius: 12px;
  background: rgba(190, 197, 206, 0.2);
  padding: 40px 50px;
  transition: background 0.3s;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  :hover {
    background: rgba(190, 197, 206, 0.3);
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const CreateMaster: FC<{ title: string }> = observer(({ title }) => {
  const navigate = useNavigate();
  const { store } = useContext(Context);
  useEffect(() => {
    if (!store.isAuth) return navigate("/");
    if (store.user.type !== "admin") return navigate(`/${store.user.type}`);
  }, [navigate, store.isAuth, store.user.type]);

  const [name, setName] = useState<string>("");
  const [result, setResult] = useState<Response>({ message: "", status: "success" });
  const [fileName, setFileName] = useState<string>("");
  const [fileLink, setFileLink] = useState<string>("");
  const fileRef: any = useRef();

  useEffect(() => {
    if (fileRef.current.files[0]) {
      const formData = new FormData();
      formData.append("file", fileRef.current.files[0]);
      axios.post(`${config.API}/file/upload`, formData).then(({ data }) => setFileLink(data.data.file));
    }
  }, [fileName]);

  const sendData = () => {
    if (!fileRef.current.files[0]) return setResult({ status: "error", message: "Укажите фото мастера" });
    if (!name) return setResult({ status: "error", message: "Укажите имя мастера" });

    $api.post(`${config.API}/master/create`, { name, photo: fileLink }).then(({ data }) => {
      if (data.status === "error") {
        return setResult({ status: "error", message: data.message });
      }
      return setResult({ status: "success", message: "Успешно!" });
    });
  };

  return (
    <Layout title={title}>
      <img src={logo} alt="Chiorio logotype" width={120} height={120} style={{ marginBottom: 50 }} />
      <CustomLink to={"/admin"}>{"<-"} Админ панель</CustomLink>
      <Row>
        <>
          <FileInput type="file" id="fileData" accept="image/*" ref={fileRef} value={fileName} onChange={({ target }) => setFileName(target.value)} />
          <ImageUploader htmlFor="fileData">
            <PhotoIcon />
            {fileName && fileRef.current.files[0] ? "Фото загружено" : "Загрузить фото"}
          </ImageUploader>
        </>
        <Column>
          <Input placeholder="Имя мастера" value={name} onChange={({ target }) => setName(target.value)} />
          <Button style={{ height: 50, marginTop: 20 }} onClick={sendData}>
            Сохранить
          </Button>
          <Result {...result} />
        </Column>
      </Row>
      {fileLink && (
        <>
          <p>Выбранная фотография:</p>
          <img src={`${config.API}/${fileLink}`} alt="Master" />
        </>
      )}
    </Layout>
  );
});

export default CreateMaster;
